module.exports = __webpack_public_path__ + "img/square-edit-gray.6e894415.svg";